import type { Editor } from "@tiptap/core";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/atoms/tooltip";
import {
  RTE_TOOLTIP_REDO,
  RTE_TOOLTIP_UNDO,
} from "@/constants/uiCopy/richTextEditor";
import { Redo2, Undo2 } from "lucide-react";
import { ToolbarButton } from "../shared/richTextEditorToolbarButton";
import { getRteShortcutKeys } from "../shared/richTextEditorToolbarShortcuts";
import { RteTooltipWithShortcut } from "../shared/richTextEditorToolbarTooltipContent";

export const RichTextEditorToolbarUndoRedo = ({
  editor,
  modKeyLabel,
  canUndo,
  canRedo,
}: {
  editor: Editor;
  modKeyLabel: string;
  canUndo: boolean;
  canRedo: boolean;
}) => {
  const keys = getRteShortcutKeys(modKeyLabel);
  return (
    <span className="flex items-center gap-1">
      <Tooltip>
        <TooltipTrigger asChild>
          <ToolbarButton
            onClick={() => editor.chain().focus().undo().run()}
            disabled={!canUndo}
            aria-label="Undo"
          >
            <Undo2 className="size-4" />
          </ToolbarButton>
        </TooltipTrigger>
        <TooltipContent>
          <RteTooltipWithShortcut label={RTE_TOOLTIP_UNDO} keys={keys.undo} />
        </TooltipContent>
      </Tooltip>
      <Tooltip>
        <TooltipTrigger asChild>
          <ToolbarButton
            onClick={() => editor.chain().focus().redo().run()}
            disabled={!canRedo}
            aria-label="Redo"
          >
            <Redo2 className="size-4" />
          </ToolbarButton>
        </TooltipTrigger>
        <TooltipContent>
          <RteTooltipWithShortcut label={RTE_TOOLTIP_REDO} keys={keys.redo} />
        </TooltipContent>
      </Tooltip>
    </span>
  );
};
